const prefix = "[TEMPLATES_OVERVIEW]";

export default {
    FETCH_TEMPLATES_REQUEST: `${prefix} FETCH_TEMPLATES_REQUEST`,
    FETCH_TEMPLATES_SUCCESS: `${prefix} FETCH_TEMPLATES_SUCCESS`,
    FETCH_TEMPLATES_FAILED: `${prefix} FETCH_TEMPLATES_FAILED`,
    DELETE_TEMPLATE_REQUEST: `${prefix} DELETE_TEMPLATE_REQUEST`,
    DELETE_TEMPLATE_SUCCESS: `${prefix} DELETE_TEMPLATE_SUCCESS`,
    DELETE_TEMPLATE_FAILED: `${prefix} DELETE_TEMPLATE_FAILED`,
};
